import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserService } from './users/user.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'GAIF_Portal';
  userService = inject(UserService);
  router = inject(Router);
  ngOnInit(): void {
    if (!this.userService.isLogin() && this.router.url === '/') {
      this.userService.logout();
    }
  }
}
